const dateFormatter = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return dateFormatter.format(date)
}

const priceFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

/** Formats a price in EUR, e.g. 990 → "990 €", 82.5 → "82,5 €". */
export function formatPrice(amount: number | null | undefined): string {
  if (amount == null || Number.isNaN(amount)) return '—'
  return priceFormatter.format(amount)
}
